/**
 * Labstep
 *
 * @module components/ProtocolValue/Form/ShowEdit/Amount
 * @desc ProtocolValue Amount
 */

import { protocolValueFieldAmount } from 'labstep-web/components/ProtocolValue/Form/fields';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import type React from 'react';
import type { IProtocolValueFormShowEditAmountProps } from './types';

export const ProtocolValueFormShowEditAmount: React.FC<
  IProtocolValueFormShowEditAmountProps
> = ({ protocolValue, placeholder }) => (
  <ShowEditText
    dataCy="components/ProtocolValue/Form/ShowEdit/Amount"
    disabled={protocolValue.has_non_limiting_reactant}
    id={protocolValue.guid}
    entityName={protocolValue.entityName}
    entity={protocolValue}
    field={protocolValueFieldAmount}
    placeholder={placeholder}
  >
    {protocolValue.amount}
  </ShowEditText>
);
